
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 17 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.667 9.94c3.828 0 7.082 1.97 8.333 4.727v-.84c0-5.013-3.684-9.102-8.333-9.409V.5L1 7.167l6.667 6.666V9.944","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    